<template>
  <div class="main">
    <!-- title -->
    <div class="subTitle">
      <el-link icon="el-icon-arrow-left" :underline="false" href="#/ourProducts"
        >Content Management - Our Products</el-link
      >
    </div>
    <h3 class="title" content="edit" placement="bottom">Edit Project</h3>
    <div>
      <el-form
        label-width="220px"
        label-position="left"
        ref="formProject"
        :model="formProject"
        :rules="formProjectRules"
        class="formProject"
      >
        <!-- step 1 -->
        <div class="detailContent" style="margin-bottom: 25px">
          <div class="requireRmarks">*Required Fields</div>
          <el-row>
            <h4>Regions</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Sales office" prop="salesOffice">
                <el-select
                  multiple
                  v-model="formProject.salesOffice"
                  :popper-append-to-body="false"
                  @change="changeSalesOffice"
                >
                  <el-option
                    v-for="(item, index) in salesOfficeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="24">
              <el-form-item label="Region" prop="region">
                <el-checkbox-group v-model="formProject.region">
                  <el-checkbox
                    :label="item.code"
                    v-for="(item, index) in regionList"
                    :key="index"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <h4>Languages</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="24">
              <el-form-item
                label="Supported Languages"
                prop="language"
                style="text-align: left"
              >
                <el-checkbox-group v-model="formProject.language">
                  <el-checkbox
                    :label="item.code"
                    v-for="(item, index) in languageList"
                    :key="index"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <!-- step 1 end -->

        <!-- step 2 -->
        <div class="detailContent">
          <el-row>
            <h4>Project Details</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Project type" prop="projectType">
                <el-select
                  v-model="formProject.projectType"
                  :popper-append-to-body="false"
                  @change="investmentInitialAmounts(formProject.projectType)"
                >
                  <el-option
                    v-for="(item, index) in projectTypeList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project Code"
                prop="projectCode"
                :rules="{
                  required: true,
                  message: 'Project Code cannot be empty',
                }"
              >
                <el-select
                  v-model="formProject.projectCode"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="(item, index) in formProject.ProductsList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Name</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project Name (EN)"
                prop="projectNameEn"
                :rules="{
                  required:
                    formProject.language.indexOf('EN') != -1 ? true : false,
                  message: 'Project Name (EN) cannot be empty',
                }"
              >
                <el-input
                  v-model="formProject.projectNameEn"
                  placeholder="Please enter"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project Name (JP)"
                prop="projectNameJp"
                :rules="{
                  required:
                    formProject.language.indexOf('JA') != -1 ? true : false,
                  message: 'Project Name (JP) cannot be empty',
                }"
              >
                <el-input
                  v-model="formProject.projectNameJp"
                  placeholder="Please enter"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project Name (TC)"
                prop="projectNameTc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_HK') != -1 ? true : false,
                  message: 'Project Name (TC) cannot be empty',
                }"
              >
                <el-input
                  v-model="formProject.projectNameTc"
                  placeholder="Please enter"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project Name (SC)"
                prop="projectNameSc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_CN') != -1 ? true : false,
                  message: 'Project Name (SC) cannot be empty',
                }"
              >
                <el-input
                  v-model="formProject.projectNameSc"
                  placeholder="Please enter"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Address</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Project Country" prop="projectLocation">
                <el-select
                  v-model="formProject.projectLocation"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="(item, index) in projectLocationList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Project State" prop="project_Status">
                <el-input
                  v-model="formProject.project_Status"
                  placeholder="Please enter"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Project Region" prop="projectRegion">
                <el-input
                  v-model="formProject.projectRegion"
                  placeholder="Please enter"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project Address (EN)"
                prop="projectAddressEn"
                :rules="{
                  required:
                    formProject.language.indexOf('EN') != -1 ? true : false,
                  message: 'Project Address (EN) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.projectAddressEn"
                  placeholder="Please enter"
                  maxlength="150"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project Address (JP)"
                prop="projectAddressJp"
                :rules="{
                  required:
                    formProject.language.indexOf('JA') != -1 ? true : false,
                  message: 'Project Address (JP) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.projectAddressJp"
                  placeholder="Please enter"
                  maxlength="150"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project Address (TC)"
                prop="projectAddressTc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_HK') != -1 ? true : false,
                  message: 'Project Address (TC) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.projectAddressTc"
                  placeholder="Please enter"
                  maxlength="150"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project Address (SC)"
                prop="projectAddressSc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_CN') != -1 ? true : false,
                  message: 'Project Address (SC) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.projectAddressSc"
                  placeholder="Please enter"
                  maxlength="150"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Details</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Property size" prop="propertySize">
                <el-input
                  v-model="formProject.propertySize"
                  placeholder="Please enter"
                  maxlength="15"
                  ><template slot="append">acres</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item style="text-align: left" label-width="0">
                <span
                  v-if="formProject.sizeUnit.indexOf('METER_SQUARE') != -1"
                  style="margin-right: 20px"
                  >{{
                    formProject.propertySize
                      ? (formProject.propertySize * 1 * 4046.85642).toFixed(3)
                      : "0"
                  }}㎡</span
                >
                <span v-if="formProject.sizeUnit.indexOf('PING') != -1"
                  >{{
                    formProject.propertySize
                      ? (formProject.propertySize * 1 * 1224.036).toFixed(3)
                      : "0"
                  }}坪</span
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Other size unit" prop="sizeUnit">
                <el-checkbox-group v-model="formProject.sizeUnit">
                  <el-checkbox
                    :label="item.code"
                    v-for="(item, index) in unitList"
                    :key="index"
                    >{{ item.name }}</el-checkbox
                  >
                </el-checkbox-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Total syndication price"
                prop="syndicationPrice"
              >
                <el-input
                  v-model="formProject.syndicationPrice"
                  placeholder="Please enter"
                  maxlength="15"
                  ><template slot="prepend">{{
                    formProject.projectLocation == "US" ? "USD" : "CAD"
                  }}</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col
              :span="12"
              v-if="formProject.salesOffice.indexOf('SG') != -1"
            >
              <el-form-item label="Minimal Investment Amount" prop="amounts">
                <el-input
                  v-model="formProject.amounts"
                  placeholder="Please enter"
                  maxlength="15"
                  ><template slot="prepend">{{
                    formProject.projectLocation == "US" ? "USD" : "CAD"
                  }}</template></el-input
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Description</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project description (EN)"
                prop="descriptionEn"
                :rules="{
                  required:
                    formProject.language.indexOf('EN') != -1 ? true : false,
                  message: 'Project description (EN) cannot be empty',
                }"
              >
                <el-input
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  type="textarea"
                  resize="none"
                  v-model="formProject.descriptionEn"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project description (JP)"
                prop="descriptionJp"
                :rules="{
                  required:
                    formProject.language.indexOf('JA') != -1 ? true : false,
                  message: 'Project description (JP) cannot be empty',
                }"
              >
                <el-input
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  type="textarea"
                  resize="none"
                  v-model="formProject.descriptionJp"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project description (TC)"
                prop="descriptionTc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_HK') != -1 ? true : false,
                  message: 'Project description (TC) cannot be empty',
                }"
              >
                <el-input
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  type="textarea"
                  resize="none"
                  v-model="formProject.descriptionTc"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project description (SC)"
                prop="descriptionSc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_CN') != -1 ? true : false,
                  message: 'Project description (SC) cannot be empty',
                }"
              >
                <el-input
                  :autosize="{ minRows: 6, maxRows: 6 }"
                  type="textarea"
                  resize="none"
                  v-model="formProject.descriptionSc"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Brief</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project brief (EN)"
                prop="briefEn"
                :rules="{
                  required:
                    formProject.language.indexOf('EN') != -1 ? true : false,
                  message: 'Project brief (EN) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.briefEn"
                  placeholder="Please enter"
                  maxlength="400"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project brief (JP)"
                prop="briefJp"
                :rules="{
                  required:
                    formProject.language.indexOf('JA') != -1 ? true : false,
                  message: 'Project brief (JP) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.briefJp"
                  placeholder="Please enter"
                  maxlength="400"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Project brief (TC)"
                prop="briefTc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_HK') != -1 ? true : false,
                  message: 'Project brief (TC) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.briefTc"
                  placeholder="Please enter"
                  maxlength="30"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Project brief (SC)"
                prop="briefSc"
                :rules="{
                  required:
                    formProject.language.indexOf('ZH_CN') != -1 ? true : false,
                  message: 'Project brief (SC) cannot be empty',
                }"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.briefSc"
                  placeholder="Please enter"
                  maxlength="400"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Land Use / Current Zoning</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Land Use / Current Zoning (EN)"
                prop="landUseEn"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.landUseEn"
                  placeholder="Please enter"
                  maxlength="500"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Land Use / Current Zoning (JP)"
                prop="landUseJp"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.landUseJp"
                  placeholder="Please enter"
                  maxlength="500"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Land Use / Current Zoning (TC)"
                prop="landUseTc"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.landUseTc"
                  placeholder="Please enter"
                  maxlength="500"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Land Use / Current Zoning (SC)"
                prop="landUseSc"
              >
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.landUseSc"
                  placeholder="Please enter"
                  maxlength="500"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Disclaimer</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Project disclaimer (EN)" prop="disclaimerEn">
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.disclaimerEn"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Project disclaimer (JP)" prop="disclaimerJp">
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.disclaimerJp"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Project disclaimer (TC)" prop="disclaimerTc">
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.disclaimerTc"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Project disclaimer (SC)" prop="disclaimerSc">
                <el-input
                  type="textarea"
                  resize="none"
                  v-model="formProject.disclaimerSc"
                  placeholder="Please enter"
                  maxlength="5000"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Images</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item prop="images">
                <div slot="label" style="display: inline-block">
                  <p style="font-size: 16px; line-height: normal">
                    Images (max.5 images)
                  </p>
                  <span style="font-size: 14px; color: rgb(79, 122, 150)"
                    >Images size:1125(W) x 705(H)</span
                  >
                </div>
                <upload-image
                  ref="UploadImage"
                  :fileParams="imagesFileParams"
                  :fileList="imagesFileList"
                  @getSuccessRes="getImgRes"
                  :limit="5"
                  :accept="'image'"
                ></upload-image>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="thumbnail">
                <div slot="label" style="display: inline-block">
                  <p style="font-size: 16px; line-height: normal">
                    Thumbnail (max.1 images)
                  </p>
                  <span style="font-size: 14px; color: rgb(79, 122, 150)"
                    >Images size:981(W) x 390(H)</span
                  >
                </div>
                <upload-image
                  ref="UploadThumbnail"
                  :fileParams="thumbnailFileParams"
                  :fileList="thumbnailFileList"
                  @getSuccessRes="getThumbnailRes"
                  :limit="1"
                  :accept="'image'"
                ></upload-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Property in map</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item prop="kmzFile" label="KMZ file">
                <upload-image
                  ref="UploadKMZ"
                  :fileParams="KMZFileParams"
                  :fileList="KMZFileList"
                  @getSuccessRes="getKMZRes"
                  :accept="'kmz'"
                  :limit="1"
                ></upload-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Property Factsheet</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item prop="facesheetEn" label="Property Factsheet (EN)">
                <upload-image
                  ref="UploadFacesheetEn"
                  :fileParams="facesheetEnFileParams"
                  :fileList="facesheetEnFileList"
                  @getSuccessRes="getFacesheetEnRes"
                  :limit="1"
                  :accept="'pdf'"
                ></upload-image>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="facesheetJp" label="Property Factsheet (JP)">
                <upload-image
                  ref="UploadFacesheetJp"
                  :fileParams="facesheetJpFileParams"
                  :fileList="facesheetJpFileList"
                  @getSuccessRes="getFacesheetJplRes"
                  :limit="1"
                  :accept="'pdf'"
                ></upload-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item prop="facesheetTc" label="Property Factsheet (TC)">
                <upload-image
                  ref="UploadFacesheetTc"
                  :fileParams="facesheetTcFileParams"
                  :fileList="facesheetTcFileList"
                  @getSuccessRes="getFacesheetTcRes"
                  :limit="1"
                  :accept="'pdf'"
                ></upload-image>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="facesheetSc" label="Property Factsheet (SC)">
                <upload-image
                  ref="UploadFacesheetSc"
                  :fileParams="facesheetScFileParams"
                  :fileList="facesheetScFileList"
                  @getSuccessRes="getFacesheetSclRes"
                  :limit="1"
                  :accept="'pdf'"
                ></upload-image>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Video</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Video (EN)" prop="videoEn">
                <el-input
                  v-model="formProject.videoEn"
                  placeholder="Please enter"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Video (JP)" prop="videoJp">
                <el-input
                  v-model="formProject.videoJp"
                  placeholder="Please enter"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Traditional Chinese / Cantonese"
                prop="videoTc_c"
              >
                <el-input
                  v-model="formProject.videoTc_c"
                  placeholder="Please enter"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="Traditional Chinese / Mandarin"
                prop="videoTc_m"
              >
                <el-input
                  v-model="formProject.videoTc_m"
                  placeholder="Please enter"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Simplified Chinese" prop="videoSc">
                <el-input
                  v-model="formProject.videoSc"
                  placeholder="Please enter"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Another Language" prop="hasAnotherLanguage">
                <el-switch
                  v-model="formProject.hasAnotherLanguage"
                  @change="handleAnotherLanguageChange"
                ></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <el-form-item label="Language Name">
                <el-col :span="6">
                  <el-form-item
                    prop="labelNameEn"
                    :rules="{
                      required: formProject.hasAnotherLanguage ? true : false,
                      message: 'Language Name (EN) can not be empty',
                    }"
                  >
                    <el-input
                      v-model="formProject.labelNameEn"
                      placeholder="English"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    prop="labelNameJp"
                    :rules="{
                      required: formProject.hasAnotherLanguage ? true : false,
                      message: 'Language Name (JP) can not be empty',
                    }"
                  >
                    <el-input
                      v-model="formProject.labelNameJp"
                      placeholder="Japanese"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    prop="labelNameTc"
                    :rules="{
                      required: formProject.hasAnotherLanguage ? true : false,
                      message: 'Language Name (TC) can not be empty',
                    }"
                  >
                    <el-input
                      v-model="formProject.labelNameTc"
                      placeholder="Traditional Chinese"
                      maxlength="20"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    prop="labelNameSc"
                    :rules="{
                      required: formProject.hasAnotherLanguage ? true : false,
                      message: 'Language Name (SC) can not be empty',
                    }"
                  >
                    <el-input
                      v-model="formProject.labelNameSc"
                      placeholder="Simplified Chinese"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item
                label="Corresponding URL"
                prop="videoAnother"
                :rules="{
                  required: formProject.hasAnotherLanguage ? true : false,
                  message: 'Corresponding URL can not be empty',
                }"
              >
                <el-input v-model="formProject.videoAnother"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider></el-divider>

          <el-row>
            <h4>Project Status</h4>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Project status" prop="projectStatus">
                <el-select
                  v-model="formProject.projectStatus"
                  :popper-append-to-body="false"
                >
                  <el-option
                    v-for="(item, index) in projectStatusList"
                    :key="index"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="New project" prop="newProject">
                <el-switch
                  v-model="formProject.newProject"
                  active-color="#003448"
                  inactive-color="#ccc"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50">
            <el-col :span="12">
              <el-form-item label="Post online" prop="postOnline">
                <el-switch
                  v-model="formProject.postOnline"
                  active-color="#003448"
                  inactive-color="#ccc"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="50" v-if="formProject.postOnline">
            <el-col :span="12">
              <el-form-item label="Online timeframe (Start)" prop="onlineTimeS">
                <el-row
                  :gutter="10"
                  justify="space-between"
                  type="flex"
                  style="margin-bottom: 0"
                >
                  <el-col :span="12">
                    <el-form-item prop="onlineTimeSD">
                      <el-date-picker
                        @change="handleOnlineDateTime('S')"
                        v-model="formProject.onlineTimeSD"
                        type="date"
                        range-separator="-"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                        placeholder="Date"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="onlineTimeST">
                      <el-time-select
                        @change="handleOnlineDateTime('S')"
                        v-model="formProject.onlineTimeST"
                        :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00',
                        }"
                        style="width: 100%"
                        placeholder="Time"
                      >
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Online timeframe (End)" prop="onlineTimeE">
                <el-row
                  :gutter="10"
                  justify="space-between"
                  type="flex"
                  style="margin-bottom: 0"
                >
                  <el-col :span="12">
                    <el-form-item prop="onlineTimeED">
                      <el-date-picker
                        @change="handleOnlineDateTime('E')"
                        v-model="formProject.onlineTimeED"
                        type="date"
                        range-separator="-"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        style="width: 100%"
                        placeholder="Date"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item prop="onlineTimeET">
                      <el-time-select
                        @change="handleOnlineDateTime('E')"
                        v-model="formProject.onlineTimeET"
                        :picker-options="{
                          start: '00:00',
                          step: '00:15',
                          end: '24:00',
                        }"
                        style="width: 100%"
                        placeholder="Time"
                      >
                      </el-time-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
      <el-col :span="4">
        <el-button
          v-if="showSave"
          class="reset"
          style="width: 100%"
          @click="handleCancel"
          >Cancel</el-button
        >
      </el-col>
      <el-col :span="4">
        <el-button
          v-if="showSave"
          type="primary"
          style="width: 100%"
          @click="handleSave"
          >Create</el-button
        >
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {
  getSalesOffice,
  getSalesRegion,
  getProjectType,
  getProjectLocation,
  getProjectUnit,
  getProjectStatus,
  projectDetail,
  projectUpdate,
  projectclone,
  appProducts,
  getAllSalesRegion,
  projectAdd,
} from "@/request/api";
import UploadImage from "@/components/common/upload/Image";
export default {
  name: "editProject",
  data() {
    var onlineTimeValidatorS = (rule, value, callback) => {
      let onlineTimeS = this.formProject.onlineTimeS;
      let onlineTimeE = this.formProject.onlineTimeE;
      if (onlineTimeS && onlineTimeE) {
        if (new Date(onlineTimeE).getTime() < new Date(onlineTimeS).getTime()) {
          callback(
            new Error("The Start Date cannot be later than the End Date")
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    var onlineTimeValidatorE = (rule, value, callback) => {
      let onlineTimeS = this.formProject.onlineTimeS;
      let onlineTimeE = this.formProject.onlineTimeE;
      if (onlineTimeS && onlineTimeE) {
        if (new Date(onlineTimeE).getTime() < new Date(onlineTimeS).getTime()) {
          callback(
            new Error("The End Date cannot be earlier than the Start Date")
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    return {
      formProjectRules: this.$validation.productEdit(
        onlineTimeValidatorS,
        onlineTimeValidatorE
      ),
      formProject: {
        ProductsList: [],
        salesOffice: [],
        region: [],
        language: [],
        projectType: "",
        projectCode: "",
        projectNameEn: "",
        projectNameJp: "",
        projectNameTc: "",
        projectNameSc: "",
        projectAddressEn: "",
        projectAddressJp: "",
        projectAddressTc: "",
        projectAddressSc: "",
        projectLocation: "US",
        projectRegion: "",
        project_Status: "",
        propertySize: "",
        sizeUnit: [],
        syndicationPrice: "",
        amounts: "",
        descriptionEn: "",
        descriptionJp: "",
        descriptionTc: "",
        descriptionSc: "",
        briefEn: "",
        briefJp: "",
        briefTc: "",
        briefSc: "",
        landUseEn: "",
        landUseJp: "",
        landUseTc: "",
        landUseSc: "",
        disclaimerEn: "",
        disclaimerJp: "",
        disclaimerTc: "",
        disclaimerSc: "",
        images: [],
        thumbnail: "",
        mapImage: {},
        kmlFile: {},
        kmzFile: "",
        facesheetEn: "",
        facesheetJp: "",
        facesheetTc: "",
        facesheetSc: "",
        videoEn: "",
        videoJp: "",
        videoTc_c: "",
        videoTc_m: "",
        videoSc: "",
        videoAnother: "",
        hasAnotherLanguage: false,
        projectStatus: "",
        newProject: false,
        postOnline: false,
        onlineTimeS: "",
        onlineTimeSD: "",
        onlineTimeST: "",
        onlineTimeE: "",
        onlineTimeED: "",
        onlineTimeET: "",
        updateBy: "",
        labelNameEn: "",
        labelNameJp: "",
        labelNameTc: "",
        labelNameSc: "",
        lastPostDate: "",
      },
      salesOfficeList: [],
      regionList: [],
      languageList: [
        { name: "English", code: "EN" },
        { name: "Traditional Chinese", code: "ZH_HK" },
        { name: "Simplified Chinese", code: "ZH_CN" },
        { name: "Japanese", code: "JA" },
      ],
      projectTypeList: [],
      projectLocationList: [],
      unitList: [],
      projectStatusList: [],
      imagesFileParams: { action: "/upload/blob/PROJECT_IMAGE" },
      imagesFileList: [],
      thumbnailFileParams: { action: "/upload/blob/PROJECT_THUMBNAIL" },
      thumbnailFileList: [],
      facesheetEnFileParams: { action: "/upload/blob/PROJECT_FACTSHEET" },
      facesheetEnFileList: [],
      facesheetJpFileParams: { action: "/upload/blob/PROJECT_FACTSHEET" },
      facesheetJpFileList: [],
      facesheetTcFileParams: { action: "/upload/blob/PROJECT_FACTSHEET" },
      facesheetTcFileList: [],
      facesheetScFileParams: { action: "/upload/blob/PROJECT_FACTSHEET" },
      facesheetScFileList: [],
      KMZFileParams: { action: "/upload/blob/PROJECT_KMZ" },
      KMZFileList: [],
      prevRoute: null,
      showSave: true,
    };
  },
  components: {
    "upload-image": UploadImage,
  },
  methods: {
    investmentInitialAmounts(val) {
      if (val === "EFPDL") this.formProject.amounts = "10000";

      if (val === "LAD") this.formProject.amounts = "20000";
    },
    //config start
    getOffice() {
      getSalesOffice().then((res) => {
        this.salesOfficeList = res.data.payload;
        if (this.$store.state.userLevel >= 2) {
          let salesOffice = this.$store.state.salesOffices;
          this.formProject.salesOffice = salesOffice;
          this.changeSalesOffice(this.formProject.salesOffice);
        }
      });
    },

    getProducts() {
      appProducts().then((res) => {
        var option = [];
        res.data.map((item) => {
          option.push({ code: item.productNumber, name: item.productNumber });
        });
        console.log(option);
        this.formProject.ProductsList = option;
      });
    },

    getType() {
      getProjectType().then((res) => {
        this.projectTypeList = res.data.payload;
      });
    },
    getLocation() {
      getProjectLocation().then((res) => {
        this.projectLocationList = res.data.payload;
      });
    },
    getUnit() {
      getProjectUnit().then((res) => {
        this.unitList = res.data.payload;
      });
    },
    getStatus() {
      getProjectStatus().then((res) => {
        this.projectStatusList = res.data.payload;
      });
    },

    // config end
    changeSalesOffice(v, callback) {
      this.clearRegion();
      if (v.length == 1) {
        getSalesRegion(v).then((res) => {
          this.regionList = res.data.payload;
          if (callback) callback();
        });
      }
      if (v.length > 1) {
        getAllSalesRegion().then((res) => {
          this.regionList = res.data.payload;
          if (callback) callback();
        });
      }
    },
    clearRegion() {
      this.regionList = [];
      this.$set(this.formProject, "region", []);
    },
    handleCancel() {
      this.$router.push("/ourProducts");
    },
    handleSave() {
      this.$refs.formProject.validate((valid) => {
        if (valid) {
          let params = {
            salesOffices: this.formProject.salesOffice,
            region: this.formProject.region,
            productType: this.formProject.projectType,
            projectCode: this.formProject.projectCode,
            language: this.formProject.language,
            projectLocation: this.formProject.projectLocation,
            isPost: this.formProject.postOnline,
            status: this.formProject.projectStatus,
            isNew: this.formProject.newProject,
            propertySize: this.formProject.propertySize,
            units: this.formProject.sizeUnit,
            images: this.formProject.images,
            thumbnail: this.formProject.thumbnail,
            address: {},
            description: {},
            brief: {},
            name: {},
            hasAnotherLanguage: this.formProject.hasAnotherLanguage,
            projectRegion: this.formProject.projectRegion,
            projectState: this.formProject.project_Status,
          };
          if (this.formProject.syndicationPrice)
            params["totalSyndicationPrice"] = this.formProject.syndicationPrice;
          if (this.formProject.amounts)
            params["investmentInitAmounts"] = this.formProject.amounts;
          if (this.formProject.kmzFile)
            params["kmzFile"] = this.formProject.kmzFile;
          if (this.formProject.postOnline) {
            params["startDate"] = this.formProject.onlineTimeS;
            params["endDate"] = this.formProject.onlineTimeE;
          }

          if (this.formProject.projectAddressEn)
            params["address"]["EN"] = this.formProject.projectAddressEn;
          if (this.formProject.projectAddressJp)
            params["address"]["JA"] = this.formProject.projectAddressJp;
          if (this.formProject.projectAddressTc)
            params["address"]["ZH_HK"] = this.formProject.projectAddressTc;
          if (this.formProject.projectAddressSc)
            params["address"]["ZH_CN"] = this.formProject.projectAddressSc;

          if (this.formProject.descriptionEn)
            params["description"]["EN"] = this.formProject.descriptionEn;
          if (this.formProject.descriptionJp)
            params["description"]["JA"] = this.formProject.descriptionJp;
          if (this.formProject.descriptionTc)
            params["description"]["ZH_HK"] = this.formProject.descriptionTc;
          if (this.formProject.descriptionSc)
            params["description"]["ZH_CN"] = this.formProject.descriptionSc;

          if (this.formProject.briefEn)
            params["brief"]["EN"] = this.formProject.briefEn;
          if (this.formProject.briefJp)
            params["brief"]["JA"] = this.formProject.briefJp;
          if (this.formProject.briefTc)
            params["brief"]["ZH_HK"] = this.formProject.briefTc;
          if (this.formProject.briefSc)
            params["brief"]["ZH_CN"] = this.formProject.briefSc;

          if (this.formProject.projectNameEn)
            params["name"]["EN"] = this.formProject.projectNameEn;
          if (this.formProject.projectNameJp)
            params["name"]["JA"] = this.formProject.projectNameJp;
          if (this.formProject.projectNameTc)
            params["name"]["ZH_HK"] = this.formProject.projectNameTc;
          if (this.formProject.projectNameSc)
            params["name"]["ZH_CN"] = this.formProject.projectNameSc;

          if (
            this.formProject.facesheetEn ||
            this.formProject.facesheetJp ||
            this.formProject.facesheetTc ||
            this.formProject.facesheetSc
          ) {
            params["propertyFactsheet"] = {};
            if (this.formProject.facesheetEn)
              params["propertyFactsheet"]["EN"] = this.formProject.facesheetEn;
            if (this.formProject.facesheetJp)
              params["propertyFactsheet"]["JA"] = this.formProject.facesheetJp;
            if (this.formProject.facesheetTc)
              params["propertyFactsheet"]["ZH_HK"] =
                this.formProject.facesheetTc;
            if (this.formProject.facesheetSc)
              params["propertyFactsheet"]["ZH_CN"] =
                this.formProject.facesheetSc;
          }
          if (
            this.formProject.landUseEn ||
            this.formProject.landUseJp ||
            this.formProject.landUseTc ||
            this.formProject.landUseSc
          ) {
            params["landUse"] = {};
            if (this.formProject.landUseEn)
              params["landUse"]["EN"] = this.formProject.landUseEn;
            if (this.formProject.landUseJp)
              params["landUse"]["JA"] = this.formProject.landUseJp;
            if (this.formProject.landUseTc)
              params["landUse"]["ZH_HK"] = this.formProject.landUseTc;
            if (this.formProject.landUseSc)
              params["landUse"]["ZH_CN"] = this.formProject.landUseSc;
          }
          if (
            this.formProject.disclaimerEn ||
            this.formProject.disclaimerJp ||
            this.formProject.disclaimerTc ||
            this.formProject.disclaimerSc
          ) {
            params["disclaimer"] = {};
            if (this.formProject.disclaimerEn)
              params["disclaimer"]["EN"] = this.formProject.disclaimerEn;
            if (this.formProject.disclaimerJp)
              params["disclaimer"]["JA"] = this.formProject.disclaimerJp;
            if (this.formProject.disclaimerTc)
              params["disclaimer"]["ZH_HK"] = this.formProject.disclaimerTc;
            if (this.formProject.disclaimerSc)
              params["disclaimer"]["ZH_CN"] = this.formProject.disclaimerSc;
          }
          if (
            this.formProject.videoEn ||
            this.formProject.videoJp ||
            this.formProject.videoTc_c ||
            this.formProject.videoTc_m ||
            this.formProject.videoSc
          ) {
            params["video"] = {};
            if (this.formProject.videoEn)
              params["video"]["EN"] = this.formProject.videoEn;
            if (this.formProject.videoJp)
              params["video"]["JA"] = this.formProject.videoJp;
            if (this.formProject.videoTc_c)
              params["video"]["ZH_HK_C"] = this.formProject.videoTc_c;
            if (this.formProject.videoTc_m)
              params["video"]["ZH_HK_M"] = this.formProject.videoTc_m;
            if (this.formProject.videoSc)
              params["video"]["ZH_CN"] = this.formProject.videoSc;
            if (this.formProject.hasAnotherLanguage)
              params["video"]["OTHER"] = this.formProject.videoAnother;
          }
          if (this.formProject.hasAnotherLanguage) {
            params["videoLabelName"] = {};
            params["videoLabelName"]["EN"] = this.formProject.labelNameEn;
            params["videoLabelName"]["JA"] = this.formProject.labelNameJp;
            params["videoLabelName"]["ZH_HK"] = this.formProject.labelNameTc;
            params["videoLabelName"]["ZH_CN"] = this.formProject.labelNameSc;
          }
          console.log(params);

          projectAdd(params).then((res) => {
            console.log(res);
            if (res.data.status == "00") {
              this.$message.success("Project is created.");
              // this.handleCancel();
              this.$router.push({
                name: "ourProducts",
                params: {
                  update: true,
                },
              });
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
    getImgRes(res) {
      console.log("images file list===", res);
      this.formProject.images = [];
      res.forEach((item) => {
        if (item.response) {
          this.formProject.images.push(item.response.payload.fileId);
        } else if (item.fileId) {
          this.formProject.images.push(item.fileId);
        } else {
          this.formProject.images.push("null");
        }
      });
      this.$refs.formProject.clearValidate("images");
      console.log("this.formProject.images ===", this.formProject.images);
    },
    getThumbnailRes(res) {
      console.log("thumbnail file list===", res);
      this.formProject.thumbnail = "";
      res.forEach((item) => {
        if (item.response) {
          this.formProject.thumbnail = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formProject.thumbnail = item.fileId;
        } else {
          this.formProject.thumbnail = "null";
        }
      });
      this.$refs.formProject.clearValidate("thumbnail");
      console.log("this.formProject.thumbnail ===", this.formProject.thumbnail);
    },
    getFacesheetEnRes(res) {
      console.log("FacesheetEn file list===", res);
      this.formProject.facesheetEn = "";
      res.forEach((item) => {
        if (item.response) {
          this.formProject.facesheetEn = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formProject.facesheetEn = item.fileId;
        } else {
          this.formProject.facesheetEn = "null";
        }
      });
      console.log(
        "this.formProject.facesheetEn ===",
        this.formProject.facesheetEn
      );
    },
    getFacesheetJplRes(res) {
      console.log("FacesheetJp file list===", res);
      this.formProject.facesheetJp = "";
      res.forEach((item) => {
        if (item.response) {
          this.formProject.facesheetJp = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formProject.facesheetJp = item.fileId;
        } else {
          this.formProject.facesheetJp = "null";
        }
      });
      console.log(
        "this.formProject.facesheetJp ===",
        this.formProject.facesheetJp
      );
    },
    getFacesheetTcRes(res) {
      console.log("FacesheetTc file list===", res);
      this.formProject.facesheetTc = "";
      res.forEach((item) => {
        if (item.response) {
          this.formProject.facesheetTc = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formProject.facesheetTc = item.fileId;
        } else {
          this.formProject.facesheetTc = "null";
        }
      });
      console.log(
        "this.formProject.facesheetTc ===",
        this.formProject.facesheetTc
      );
    },
    getFacesheetSclRes(res) {
      console.log("FacesheetSc file list===", res);
      this.formProject.facesheetSc = "";
      res.forEach((item) => {
        if (item.response) {
          this.formProject.facesheetSc = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formProject.facesheetSc = item.fileId;
        } else {
          this.formProject.facesheetSc = "null";
        }
      });
      console.log(
        "this.formProject.facesheetSc ===",
        this.formProject.facesheetSc
      );
    },
    getKMZRes(res) {
      console.log("KMZ file list===", res);
      this.formProject.kmzFile = "";
      res.forEach((item) => {
        if (item.response) {
          this.formProject.kmzFile = item.response.payload.fileId;
        } else if (item.fileId) {
          this.formProject.kmzFile = item.fileId;
        } else {
          this.formProject.kmzFile = "null";
        }
      });
      console.log("this.formProject.kmzFile ===", this.formProject.kmzFile);
    },
    handleAnotherLanguageChange(v) {
      this.$refs.formProject.clearValidate([
        "labelNameEn",
        "labelNameJp",
        "labelNameTc",
        "labelNameSc",
        "videoAnother",
      ]);
    },
    handleOnlineDateTime(str) {
      if (str == "S") {
        if (this.formProject.onlineTimeSD && this.formProject.onlineTimeST) {
          this.formProject.onlineTimeS =
            this.formProject.onlineTimeSD + " " + this.formProject.onlineTimeST;
          if (this.formProject.onlineTimeE) {
            this.$refs.formProject.validateField([
              "onlineTimeS",
              "onlineTimeE",
            ]);
          } else {
            this.$refs.formProject.validateField(["onlineTimeS"]);
          }
        } else {
          this.formProject.onlineTimeS = "";
          this.$refs.formProject.validateField(["onlineTimeS"]);
        }
      }
      if (str == "E") {
        if (this.formProject.onlineTimeED && this.formProject.onlineTimeET) {
          this.formProject.onlineTimeE =
            this.formProject.onlineTimeED + " " + this.formProject.onlineTimeET;
          if (this.formProject.onlineTimeS) {
            this.$refs.formProject.validateField([
              "onlineTimeS",
              "onlineTimeE",
            ]);
          } else {
            this.$refs.formProject.validateField(["onlineTimeE"]);
          }
        } else {
          this.formProject.onlineTimeE = "";
          this.$refs.formProject.validateField(["onlineTimeE"]);
        }
      }
    },
    getDetail() {
      let id = this.$route.params.id;
      projectDetail(id).then((res) => {
        console.log(res);
        let detail = res.data.payload;
        //region

        var salesOffice = [];
        salesOffice[0] = detail.salesOffice;
        this.formProject.salesOffice = salesOffice;
        this.changeSalesOffice(this.formProject.salesOffice, () => {
          this.formProject.region = detail.region;
        });
        //language
        this.formProject.language = detail.language;
        //detail
        this.formProject.projectType = detail.productType;
        this.formProject.projectCode = detail.projectCode;
        //name
        this.formProject.projectNameEn = detail.name.EN ? detail.name.EN : "";
        this.formProject.projectNameJp = detail.name.JA ? detail.name.JA : "";
        this.formProject.projectNameTc = detail.name.ZH_HK
          ? detail.name.ZH_HK
          : "";
        this.formProject.projectNameSc = detail.name.ZH_CN
          ? detail.name.ZH_CN
          : "";
        //address
        this.formProject.projectLocation = detail.projectLocation;
        this.formProject.projectRegion = detail.projectRegion;
        this.formProject.project_Status = detail.projectState;
        this.formProject.projectAddressEn = detail.address.EN
          ? detail.address.EN
          : "";
        this.formProject.projectAddressJp = detail.address.JA
          ? detail.address.JA
          : "";
        this.formProject.projectAddressTc = detail.address.ZH_HK
          ? detail.address.ZH_HK
          : "";
        this.formProject.projectAddressSc = detail.address.ZH_CN
          ? detail.address.ZH_CN
          : "";
        //detail
        this.formProject.propertySize = detail.propertySize;
        this.formProject.sizeUnit = detail.units;
        this.formProject.syndicationPrice = detail.totalSyndicationPrice;
        this.formProject.amounts = detail.investmentInitAmounts;
        //description
        this.formProject.descriptionEn = detail.description.EN
          ? detail.description.EN
          : "";
        this.formProject.descriptionJp = detail.description.JA
          ? detail.description.JA
          : "";
        this.formProject.descriptionTc = detail.description.ZH_HK
          ? detail.description.ZH_HK
          : "";
        this.formProject.descriptionSc = detail.description.ZH_CN
          ? detail.description.ZH_CN
          : "";
        //brief
        this.formProject.briefEn = detail.brief.EN ? detail.brief.EN : "";
        this.formProject.briefJp = detail.brief.JA ? detail.brief.JA : "";
        this.formProject.briefTc = detail.brief.ZH_HK ? detail.brief.ZH_HK : "";
        this.formProject.briefSc = detail.brief.ZH_CN ? detail.brief.ZH_CN : "";
        //land use
        this.formProject.landUseEn = detail.landUse.EN ? detail.landUse.EN : "";
        this.formProject.landUseJp = detail.landUse.JA ? detail.landUse.JA : "";
        this.formProject.landUseTc = detail.landUse.ZH_HK
          ? detail.landUse.ZH_HK
          : "";
        this.formProject.landUseSc = detail.landUse.ZH_CN
          ? detail.landUse.ZH_CN
          : "";
        //disclaimer
        this.formProject.disclaimerEn = detail.disclaimer.EN
          ? detail.disclaimer.EN
          : "";
        this.formProject.disclaimerJp = detail.disclaimer.JA
          ? detail.disclaimer.JA
          : "";
        this.formProject.disclaimerTc = detail.disclaimer.ZH_HK
          ? detail.disclaimer.ZH_HK
          : "";
        this.formProject.disclaimerSc = detail.disclaimer.ZH_CN
          ? detail.disclaimer.ZH_CN
          : "";
        //images
        this.formProject.images = [];
        this.imagesFileList = [];
        detail.images.forEach((item) => {
          let obj = {
            name: item.fileName,
            url: item.filePath,
            fileId: item.fileId,
          };
          this.imagesFileList.push(obj); //file list
          this.formProject.images.push(item.fileId);
        });
        //thumbnail
        this.thumbnailFileList = [];
        let thumbnailItem = {
          name: detail.thumbnail.fileName,
          url: detail.thumbnail.filePath,
          fileId: detail.thumbnail.fileId,
        };
        this.thumbnailFileList.push(thumbnailItem);
        this.formProject.thumbnail = detail.thumbnail.fileId;
        //map

        //kmz
        this.KMZFileList = [];
        if (detail.kmzFile) {
          let KMZItem = {
            name: detail.kmzFile.fileName,
            url: detail.kmzFile.filePath,
            fileId: detail.kmzFile.fileId,
          };
          this.KMZFileList.push(KMZItem);
          this.formProject.kmzFile = detail.kmzFile.fileId;
        }

        //facesheet
        this.facesheetEnFileList = [];
        this.facesheetJpFileList = [];
        this.facesheetTcFileList = [];
        this.facesheetScFileList = [];
        if (detail.propertyFactsheet) {
          if (detail.propertyFactsheet.EN) {
            let faceSheetEnItem = {
              name: detail.propertyFactsheet.EN.fileName,
              url: detail.propertyFactsheet.EN.filePath,
              fileId: detail.propertyFactsheet.EN.fileId,
            };
            this.facesheetEnFileList.push(faceSheetEnItem);
            this.formProject.facesheetEn = detail.propertyFactsheet.EN.fileId;
          }
          if (detail.propertyFactsheet.JA) {
            let faceSheetJpItem = {
              name: detail.propertyFactsheet.JA.fileName,
              url: detail.propertyFactsheet.JA.filePath,
              fileId: detail.propertyFactsheet.JA.fileId,
            };
            this.facesheetJpFileList.push(faceSheetJpItem);
            this.formProject.facesheetJp = detail.propertyFactsheet.JA.fileId;
          }
          if (detail.propertyFactsheet.ZH_HK) {
            let faceSheetTcItem = {
              name: detail.propertyFactsheet.ZH_HK.fileName,
              url: detail.propertyFactsheet.ZH_HK.filePath,
              fileId: detail.propertyFactsheet.ZH_HK.fileId,
            };
            this.facesheetTcFileList.push(faceSheetTcItem);
            this.formProject.facesheetTc =
              detail.propertyFactsheet.ZH_HK.fileId;
          }
          if (detail.propertyFactsheet.ZH_CN) {
            let faceSheetScItem = {
              name: detail.propertyFactsheet.ZH_CN.fileName,
              url: detail.propertyFactsheet.ZH_CN.filePath,
              fileId: detail.propertyFactsheet.ZH_CN.fileId,
            };
            this.facesheetScFileList.push(faceSheetScItem);
            this.formProject.facesheetSc =
              detail.propertyFactsheet.ZH_CN.fileId;
          }
        }
        //video
        this.formProject.videoEn = detail.video.EN ? detail.video.EN : "";
        this.formProject.videoJp = detail.video.JA ? detail.video.JA : "";
        this.formProject.videoTc_c = detail.video.ZH_HK_C
          ? detail.video.ZH_HK_C
          : "";
        this.formProject.videoTc_m = detail.video.ZH_HK_M
          ? detail.video.ZH_HK_M
          : "";
        this.formProject.videoSc = detail.video.ZH_CN ? detail.video.ZH_CN : "";
        this.formProject.videoAnother = detail.video.OTHER
          ? detail.video.OTHER
          : "";
        //label name
        this.formProject.labelNameEn = detail.videoLabelName.EN
          ? detail.videoLabelName.EN
          : "";
        this.formProject.labelNameJp = detail.videoLabelName.JA
          ? detail.videoLabelName.JA
          : "";
        this.formProject.labelNameTc = detail.videoLabelName.ZH_HK
          ? detail.videoLabelName.ZH_HK
          : "";
        this.formProject.labelNameSc = detail.videoLabelName.ZH_CN
          ? detail.videoLabelName.ZH_CN
          : "";
        //another language
        this.formProject.hasAnotherLanguage = detail.hasAnotherLanguage;

        //project status
        this.formProject.projectStatus = detail.status ? detail.status : "";
        this.formProject.newProject = detail.isNew;
        this.formProject.postOnline = detail.isPost;
        // this.formProject.onlineTime = [detail.startDate,detail.endDate];
        this.formProject.onlineTimeS = detail.startDate;
        this.formProject.onlineTimeE = detail.endDate;
        this.formProject.onlineTimeSD = detail.startDate.split(" ")[0];
        this.formProject.onlineTimeST = detail.startDate.split(" ")[1];
        this.formProject.onlineTimeED = detail.endDate.split(" ")[0];
        this.formProject.onlineTimeET = detail.endDate.split(" ")[1];
        //update by
        this.formProject.updateBy =
          detail.updatedByName && detail.updatedAt
            ? detail.updatedByName +
              ", " +
              this.$commonjs.paramFormatDate(detail.updatedAt)
            : "-";
        //last post date
        this.formProject.lastPostDate =
          detail.lastStartDate && detail.lastEndDate
            ? detail.lastStartDate + " ~ " + detail.lastEndDate
            : "-";
      });
    },
    showBtn(val) {
      console.log(this.$store.state.permissions);
      var permissions = this.$store.state.permissions.filter(
        (item) => item == val
      );
      if (!permissions[0]) {
        this.showSave = false;
      }
    },
  },
  created: function () {
    this.getOffice();
    this.getType();
    this.getLocation();
    this.getUnit();
    this.getStatus();
    this.getDetail();
    this.showBtn("CONTENT_WRITE");
    this.getProducts();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from;
    });
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== "ourProducts") {
      this.prevRoute.meta.keepAlive = false;
    }
    next();
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.stepBox,
.stepBox p {
  display: flex;
  align-items: center;
  justify-content: center;
}
.activeStep {
  background-color: rgb(85, 130, 160);
  color: #fff;
}
.step {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  line-height: 24px;
  margin-right: 8px;
  font-size: 14px;
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/content/product/editProjectClone.vue